import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import CustomSignature from '../customoptions/CustomSignature.vue';

export default Node.create({
    name: 'CustomSignature',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            signature: {
                default: null,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'CustomSignature',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['CustomSignature', mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(CustomSignature);
    },

    addCommands() {
        return {
            insertCustomSignature:
                (props) =>
                ({ commands }) => {
                    commands.insertContent({
                        type: this.name,
                        attrs: props,
                    }),
                        {
                            parseOptions: {
                                preserveWhitespace: 'full',
                            },
                        };
                    return true;
                },
        };
    },
});
